import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Text from "components/common/Text";
import { useHistory } from "react-router-dom";
import TextField from "components/common/TextField";
import Box from "components/common/Box";
import Button from "components/common/Button";
import Stack from "components/common/Stack";
import { Formik } from "formik";
import * as yup from "yup";
import CTable from "components/common/Table";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Switch from "../../common/Switch";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const AddVehicleManufacturer = ({
  submitManufacturer,
  loading,
  onClickEdit,
  data,
  handleStatusAddVehicle,
}) => {
  const classes = useStyles();



  let history = useHistory();

  const initialValues = {
    manufacturername: "",
    file: null,
  };

  const validateManufacturerForm = yup.object().shape({
    manufacturername: yup
      .string()
      .required("Manufacturer name is required")
      .trim("Manufacturer cannot contain extra spaces")
      .strict(true)
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field "),

    file: yup
      .mixed()
      .required("upload image in only jpeg/jpg/png format")
      .test(
        "FILE_SIZE",
        "Image size should be less than 1 MB",
        (value) => !value || (value && value.size <= 1024 * 1024)
      ),
  });
  const columns = [
    {
      field: "name",
      headerName: "Name of Vehicle Manufacturers",
    },

    {
      field: "price",
      headerName: "Action",
      valueGetter: (v, d) => {
        return (
          <>
            {
              <>
                <EditOutlinedIcon
                  className={classes.Editicon}
                  onClick={() => {
                    onClickEdit(d.id, d.name,d.thumbnail);
                  }}
                  sx={{
                    cursor: "pointer",
                    color: "#004AAD",
                    marginLeft: "36%",
                  }}
                />

                {
                  <Switch
                    checked={d.status === 1 ? true : false}
                    onClick={() =>
                      handleStatusAddVehicle(d.id, d.status, d.name)
                    }
                    sx={{ marginBottom: "20px" }}
                  />
                }
              </>
            }
          </>
        );
      },
    },
  ];

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values, { resetForm }) => {
        
          let formData = new FormData();
          formData.append("name", values.manufacturername);
          formData.append("file", values.file);
          submitManufacturer(formData).then(() => {
            resetForm(); 
            document.getElementById("file").value = ""; 
          });
        }}
        validationSchema={validateManufacturerForm}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          isValid,
          values,
          touched,
          errors,
          setFieldValue,
        }) => (
          <>
            <Box>
              <Text
                className={classes.menutext}
                variant="h5"
                color="#202020"
                sx={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginBottom: "40px",
                }}
              >
                <ArrowBackIcon
                  sx={{
                    fontSize: "22px",
                    fontWeight: "bold",
                  }}
                  onClick={() => history.goBack()}
                />
                Add Vehicle Manufacturer
              </Text>

              <Stack direction={"row"} spacing={25.5}>
                <Stack xs={6}>
                  <Text sx={{ color: "#666666", fontSize: "14px" }}>
                    Enter Manufacturer Name
                  </Text>
                  <Box className={classes.menuinput} sx={{ width: "20rem" }}>
                    <TextField
                      size="small"
                      sx={{ width: "19rem" }}
                      onInput={(e) => {
                        e.target.value = e.target.value.trimStart();
                      }}
                      onBlur={handleBlur("manufacturername")}
                      onChange={handleChange("manufacturername")}
                      value={values.manufacturername}
                      error={
                        !touched.manufacturername &&
                        Boolean(errors.manufacturername)
                      }
                    />

                    {errors.manufacturername && (
                      <Typography sx={{ color: "red" }}>
                        {errors.manufacturername}
                      </Typography>
                    )}
                  </Box>
                </Stack>

                <Stack xs={6}>
                  <Text sx={{ color: "#666666", fontSize: "14px" }}>
                    Add Manufacturer Image
                  </Text>
                  <Box
                    className={classes.form_container}
                    sx={{ marginTop: "-10px" }}
                  >
                    <Box
                      sx={{
                        width: "300px",
                        height: "25px",
                        border: "1px solid rgba(0, 0, 0, 0.27)",
                        padding: "10px 10px",
                        borderRadius: "5px",
                      }}
                    >
                      <input
                        id="file"
                        name="photo"
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={(event) => {
                          setFieldValue("file", event.currentTarget.files[0]);
                        }}
                        error={!touched.file && Boolean(errors.file)}
                      />
                      {errors.file && (
                        <Typography sx={{ color: "red", margin: "15px -10px" }}>
                          {errors.file}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Stack>
              </Stack>

              <Stack mt={1.5} direction={"column"}>
                <Button
                  variant="outlined"
                  sx={{
                    width: "94.17px",
                    height: "51.41px",
                    fontSize: "16px",
                    borderColor: "#0071C5",
                    color: "#0071C5",
                  }}
                  size="small"
                  onClick={() => {
                    handleSubmit();
                  }}
                  disabled={!isValid}
                >
                  + Add
                </Button>
              </Stack>

              <Stack mt={7}>
                <CTable
                  columns={columns}
                  data={data}
                  isLoading={loading?.isLoading}
                  pagination={true}
                  localPagination={true}
                  page={0}
                  rowsPerPage={5}
                ></CTable>
              </Stack>
            </Box>
          </>
        )}
      </Formik>
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  menuinput: {
    "@media (max-width:768px)": {
      width: "100%",
    },
  },
  menutext: {
    "@media (max-width:768px)": {
      fontSize: "20px",
    },
  },
  Editicon: {
    "@media (max-width:768px)": {
      marginLeft: "-28px",
    },
  },

  form_container: {
    padding: "10px 0 0 0",
    width: "80%",
    "@media (max-width:768px)": {
      padding: "1rem",
      width: "90%",
      margin: "auto",
    },
  },
}));
export default AddVehicleManufacturer;
